/**
 * Admin routes (§33–§40, §109). Every page is loaded lazily, so the public bundle (participants on
 * mobile) does not contain admin code. Protected pages render inside `AdminShell` (auth guard +
 * layout); login pages are outside it.
 */
import type { RouteObject } from 'react-router';

export const adminRoutes: RouteObject[] = [
  {
    path: 'login',
    lazy: async () => ({ Component: (await import('./auth/LoginPage')).LoginPage }),
  },
  {
    path: 'login/verify',
    lazy: async () => ({ Component: (await import('./auth/LoginVerifyPage')).LoginVerifyPage }),
  },
  {
    lazy: async () => ({ Component: (await import('./auth/AdminShell')).AdminShell }),
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./dashboard/DashboardPage')).DashboardPage,
        }),
      },
      {
        path: 'companies',
        lazy: async () => ({
          Component: (await import('./companies/CompaniesPage')).CompaniesPage,
        }),
      },
      {
        path: 'companies/:id',
        lazy: async () => ({
          Component: (await import('./companies/CompanyDetailPage')).CompanyDetailPage,
        }),
      },
      {
        path: 'batches',
        lazy: async () => ({ Component: (await import('./batches/BatchesPage')).BatchesPage }),
      },
      {
        path: 'batches/:id',
        lazy: async () => ({
          Component: (await import('./batches/BatchDetailPage')).BatchDetailPage,
        }),
      },
      {
        path: 'registrations',
        lazy: async () => ({
          Component: (await import('./registrations/RegistrationsPage')).RegistrationsPage,
        }),
      },
      {
        path: 'registrations/:id',
        lazy: async () => ({
          Component: (await import('./registrations/RegistrationDetailPage'))
            .RegistrationDetailPage,
        }),
      },
      {
        path: 'operations',
        lazy: async () => ({
          Component: (await import('./operations/OperationsPage')).OperationsPage,
        }),
      },
      {
        path: 'audit',
        lazy: async () => ({ Component: (await import('./audit/AuditLogPage')).AuditLogPage }),
      },
      {
        path: 'admin-users',
        lazy: async () => ({
          Component: (await import('./admin-users/AdminUsersPage')).AdminUsersPage,
        }),
      },
    ],
  },
];
